import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SiteNav } from "@/components/SiteNav";
import { SiteFooter } from "@/components/SiteFooter";
import { AngelikaChat } from "@/components/AngelikaChat";
import { ProjektBeschreibenForm } from "@/components/ProjektBeschreibenForm";

const searchSchema = z.object({
  mode: z.enum(["upload", "form"]).optional(),
});

export const Route = createFileRoute("/projekt-beschreiben")({
  validateSearch: searchSchema,
  head: () => ({
    meta: [
      { title: "Ihr Vorhaben beschreiben – Energy Prime 360" },
      {
        name: "description",
        content:
          "Beschreiben Sie Ihr Vorhaben strukturiert, per Sprache oder Text und laden Sie Ihre Unterlagen & Angebote für eine kostenlose Analyse hoch.",
      },
    ],
  }),
  component: ProjektBeschreiben,
});

function ProjektBeschreiben() {
  return (
    <div className="min-h-screen bg-[#f4f6fa] text-navy">
      <SiteNav />
      <main>
        <ProjektBeschreibenForm />
      </main>
      <SiteFooter />
      <AngelikaChat />
    </div>
  );
}
